// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__q2H-S","box":"style_box__8qsqk","active":"style_active__Y2-g5","title":"style_title__jGwnY","item":"style_item__pur1y"};